import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import WritePostForm from '../../components/common/WritePostForm';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import { BoardInfo } from '../../types/post';

const CoffeeChatWrite: React.FC = () => {
  const { lecturerId } = useParams<{ lecturerId: string }>();
  const navigate = useNavigate();
  
  const handleSubmit = async (postData: any) => {
    try {
      // API 호출이 WritePostForm에서 이미 완료되었으므로
      // 여기서는 성공 메시지와 리다이렉션만 처리
      alert('질문이 성공적으로 등록되었습니다!');

      // 해당 연자의 커피챗 상세 페이지로 이동
      if (lecturerId) {
        navigate(`/coffee-chat/${lecturerId}`);
      } else {
        navigate('/coffee-chat');
      }
      
    } catch (error) {
      /// console.error('질문 등록 실패:', error);
      alert('질문 등록에 실패했습니다. 다시 시도해주세요.');
    }
  };

  const handleCancel = () => {
    if (window.confirm('작성 중인 내용이 있습니다. 정말 취소하시겠습니까?')) {
      if (lecturerId) {
        navigate(`/coffee-chat/${lecturerId}`);
      } else {
        navigate('/coffee-chat');
      }
    }
  };

  // 커피챗 글쓰기를 위한 설정
  const categories = [
    { id: 'coffee-chat', name: '커피챗', value: 'coffee-chat' }
  ];

  const boards: BoardInfo[] = [
    { 
      id: 'coffee-chat', 
      name: '커피챗', 
      category: 'coffee-chat', 
      apiCategory: '커피챗' as const 
    }
  ];

  return (
    <>
      <Header />
      <Container>
        <BackButton onClick={() => navigate(-1)}>
          <BackIcon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path 
                d="M15 18L9 12L15 6" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </BackIcon>
          뒤로가기
        </BackButton>
        
        <ContentWrapper>
          <WritePostForm
            categories={categories}
            boards={boards}
            initialCategory="coffee-chat"
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            lecturerId={lecturerId ? parseInt(lecturerId) : undefined}
          />
        </ContentWrapper>
      </Container>
      <Footer />
    </>
  );
};

const Container = styled.div`
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 0 128px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  
  @media (max-width: 1024px) {
    padding: 32px 0 96px 0;
  }
  
  @media (max-width: 768px) {
    padding: 24px 0 64px 0;
  }
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px 0 0;
  border: none;
  background: transparent;
  color: rgba(55, 56, 60, 0.61);
  font-size: 14px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  align-self: flex-start;
  margin-left: 0;

  &:hover {
    background: rgba(112, 115, 124, 0.08);
    color: #171719;
  }
`;

const BackIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  width: 100%;
  flex: 1;
`;

export default CoffeeChatWrite;
